import React from "react";
import { Button, Modal } from "semantic-ui-react";
import "./CecoCareModal.scss";
import { usePolyglot } from "ceco-polyglot";

export default function CecoCareModal({
  cecoCarePopupIsVisible,
  setCecoCareIsVisible,
}) {
  const polyglot = usePolyglot();
  const t = polyglot.t.bind(polyglot);

  return (
    <Modal
      className="ceco-care-modal"
      closeIcon
      centered={false}
      open={cecoCarePopupIsVisible}
      onClose={() => setCecoCareIsVisible(false)}
    >
      <Modal.Content>
        <Modal.Description>
          <h3>
            {t("cecocare_modal.title")}{" "}
            <a
              href="https://support.storececotec.com/"
              rel="noreferrer noopener"
            >
              CecoCare
            </a>
          </h3>
          <div>
            <Button
              as="a"
              download
              target="_blank"
              href="https://s3.eu-west-1.amazonaws.com/manuals.cecotec.es/manuales/ManualCecoCare_CanalHorizontal_v2.pdf"
              basic
              icon="download"
              content={t("cecocare_modal.download_manual")}
            />
            <Button
              as="a"
              href="https://support.storececotec.com/"
              primary
              icon="right arrow"
              content={t("cecocare_modal.go_to_cecocare")}
            />
          </div>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setCecoCareIsVisible(false)}>Cerrar</Button>
      </Modal.Actions>
    </Modal>
  );
}
